"use client";

import { size, theme } from "@/config/theme";
import { SCContainerContent } from "@/utils/styledComponents";
import Image from "next/image";
import styled from "styled-components";
import imageSSTA from "/public/media/images/image-press-ssta.png";
import imageSME500 from "/public/media/images/image-press-sme500.png";
import { breakpoints } from "@/utils/breakpoint";
import EmblaCarousel from "./Component-EmblaCarousel-InThePress";
import { EmblaOptionsType } from "embla-carousel";
import { useTranslations } from "next-intl";

const imageList = [
    {
        src: imageSSTA,
        alt: "Singapore Swimming Teachers' Association (SSTA) logo"
    },
    {
        src: imageSME500,
        alt: "SME 500 award logo"
    }
];

const InThePress = () => {
    const t = useTranslations("InThePress");
    const OPTIONS: EmblaOptionsType = { loop: true };
    const SLIDES = imageList;

    return (
        <SCInThePress>
            <SCInThePressContent>
                <div className="text-largexlarge">{t("title-text")}</div>
                <div className="image-container non-mobile-view">
                    {imageList.map((item, index) => (
                        <Image key={index} src={item.src} alt={item.alt} />
                    ))}
                </div>
                <div className="carousel-container mobile-view">
                    <EmblaCarousel slides={SLIDES} options={OPTIONS} />
                </div>
            </SCInThePressContent>
        </SCInThePress>
    );
};

export default InThePress;

const SCInThePress = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: ${theme["spacing-lxl"]} 0;
`;

const SCInThePressContent = styled(SCContainerContent)`
    display: flex;
    flex-direction: row;
    align-items: center;

    // Mobile view
    ${breakpoints(
        "flex-direction",
        "",
        [{ [size.px.sxs]: "column" }],
        "max-width"
    )};

    .text-largexlarge {
        font-size: ${theme["fontsize-lxl"]};
        font-weight: 500;
        margin-right: ${theme["spacing-l"]};

        ${breakpoints(
            "margin-right",
            "",
            [{ [size.px.sxs]: "0" }],
            "max-width"
        )};
        ${breakpoints(
            "margin-bottom",
            "px",
            [{ [size.px.sxs]: "32" }],
            "max-width"
        )};
    }

    .image-container {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        img {
            margin-right: ${theme["spacing-lxl"]};

            &:last-child {
                margin-right: 0;
            }
        }
    }

    .carousel-container {
        width: 100%;
    }

    .non-mobile-view {
        ${breakpoints("display", "", [{ [size.px.sxs]: "none" }], "max-width")};
    }

    .mobile-view {
        ${breakpoints(
            "display",
            "",
            [{ [(parseInt(size.px.sxs) + 1).toString()]: "none" }],
            "min-width"
        )};
    }
`;
